import react from 'react';

export default class Alert extends react.Component {
  constructor(props) {
    super(props);
    this.state = { 
      onClick: props.onClick,
      variant: props.variant,
      children: props.children
    };
  }

  componentWillReceiveProps(props) {
    this.setState(
      { 
        message: props.message, 
      });  
  }

  render() {
    // Set alert variant class
    let variantClass = '';
    switch (this.state.variant) {
      case 'danger' || 'error':
        variantClass = 'alert-danger';
        break;
      case 'warning':
        variantClass = 'alert-warning';
        break;
      case 'success':
        variantClass = 'alert-success';
        break;
      case 'info':
        variantClass = 'alert-info';
        break;
      default:
        variantClass = 'alert-secondary';
    }

    return <div className={`alert ${variantClass}`} role="alert">
    <div className="alert-message">
     {this.state.children} 
    </div>
    {this.state.onClick && <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick = {this.state.onClick}>
      <i className="icon icon-times" aria-hidden="true" />
    </button>}
  </div>
  }
}